<template lang="pug">
	.asset-preview-mini(v-if="showed" v-pseudo-modal="'asset-preview'" :style="{top: top + 'px', right: right + 'px'}")
		.img-asset-preview(v-if="asset && (asset.type === 'image' || asset.type === 'atlas')")
			.unsupported-format(v-if="assetText")
				i.fa.fa-exclamation-triangle
				span {{assetText}}
			img(v-if="assetURL" :src="assetURL")

</template>

<script>

	import Screen 			from './../../mixins/screen';
	import { Asset } 		from './../../services/Asset';

	export default {
		name: "AssetPreviewMini",
		mixins: [Screen],
		screen: {
			events: {
				"Show Asset Preview": function(asset, e, el) {

					if (Asset.isRandomAsset(asset) || !_.includes(['image', 'atlas'], asset.type)) {
						this.asset = null;
						return;
					}

					this.asset = asset;

					if (!asset.isHDR) {
						this.assetURL = Asset.getAssetActualUrl(asset, {addTimestamp: true, imagesForAtlases: true});
						this.assetText = '';
					} else {
						this.assetURL = '';
						this.assetText = 'Unfortunately preview for hdr assets is not available';
					}

					this.update();

					let rect = el.getBoundingClientRect();

					this.top = rect.top;
					this.right = document.body.clientWidth - rect.left;

					Broadcast.call("Pseudo Modal Show", ["asset-preview"]);

				},
				"Hide Asset Preview": function() {

					this.asset = null;

					this.update();

					Broadcast.call("Pseudo Modal Hide", ["asset-preview"]);

				}
			}
		},
		data() {

			this.asset = null;
			this.assetURL = '';
			this.assetText = '';

			return {
				showed: true,
				top: 0,
				right: 0
			};

		},
		computed: {

		},
		methods: {
			collectData() {

			}
		}
	}
</script>

<style lang="sass">

	.asset-preview-mini
		position: absolute
		z-index: 10000
		top: 0
		right: 0
		border-radius: 0.25rem
		padding: 0.25rem
		border: 1px solid #23282c
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)
		background-color: #3a4149

		.img-asset-preview


			i
				padding-right: 10px
			i, span
				color: #ff9a47

			img
				max-width: 100px
				max-height: 100px

</style>
